import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of, Observable } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';

import * as AuthActions from '../../actions';
import { AuthService } from 'src/app/services/SicarMap/auth.service';


@Injectable()
export class authEffects {

    constructor(
        private actions$: Actions,
        private authService: AuthService,
    ) { }

    // effects go here
    @Effect()
    LogIn$: Observable<any> = this.actions$.pipe(
        ofType(AuthActions.AuthActionTypes.LOGIN),
        switchMap((action: AuthActions.LogIn) => {
            return action.Credenciales !== null ?
                this.authService.login(action.Credenciales)
                    .pipe(
                        map((Datos: any) => {
                            this.authService.IdUsuario = Datos.pidusuario;
                            this.authService.Usuario = Datos;
                            return new AuthActions.LogInSuccess(Datos);
                        }),
                        catchError(error => of(new AuthActions.LogInFailure({ error })))
                    ) :
                this.authService.getUser()
                    .pipe(
                        map((Datos: any) => {
                            this.authService.IdUsuario = Datos.pidusuario;
                            this.authService.Usuario = Datos;
                            return new AuthActions.LogInSuccess(Datos);
                        }),
                        catchError(error => of(new AuthActions.LogInFailure({ error })))
                    );
        }
        )
    );
}
